import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Collapse from './Collapse.vue';
export default {
  meta: {
    title: '运费模板',
    auth: true,
    authorityValue: "store-delivery-temp"
  },
  name: 'transport',
  components: {
    Collapse: Collapse
  },
  data: function data() {
    return {
      tableData: [],
      total: 0
    };
  },
  created: function created() {
    this.getDeliveryFees();
  },
  methods: {
    pagination: function pagination(item) {
      this.getDeliveryFees(item);
    },
    getDeliveryFees: function getDeliveryFees(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$_this$$api$del, total, records;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$api.deliveryFees(_objectSpread({}, data));

              case 2:
                _yield$_this$$api$del = _context.sent;
                total = _yield$_this$$api$del.total;
                records = _yield$_this$$api$del.records;
                _this.total = total;
                _this.tableData = records;

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    clickDel: function clickDel(data) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$api.deleteDeliveryFee(data);

              case 2:
                YL.message('成功删除');

                _this2.getDeliveryFees();

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};